import { Stem, StemGraphicHotspot } from "@examspark/types";

import { getNewScore } from ".";

export const scoreGraphicHotspot = (
  expected: StemGraphicHotspot,
  actual: Partial<Stem.Response>,
) => {
  const { scoring } = expected;
  const score = getNewScore();
  const keys: Array<string> = [];

  for (const k of Object.keys(scoring?.spots ?? {})) {
    const element = scoring?.spots?.[k];
    if (element?.isKey) {
      keys.push(k);
    }
  }

  score.max = keys.length;
  if (!actual?.spots) {
    return score;
  }

  // award 1 point for each correct spot
  for (const spot of actual.spots) {
    if (keys.includes(spot)) {
      score.actual++;
    }
  }

  // penalize 1 point for each extra spot (more than the expected count)
  if (actual.spots.length > keys.length) {
    score.actual = score.actual - (actual.spots.length - keys.length);
  }

  if (score.actual < 0) {
    score.actual = 0;
  }

  return score;
};
